import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import * as actions from '../actions/imeiSearchActions';
import ImeiSearchResult from './ImeiSearchResult';
import ErrorWrongApproach from './ErrorWrongApproach';
import * as errorMessages from '../constants/errorMessages';

export class ImeiSearchPage extends React.Component{

  constructor(props, context) {
    super(props, context);
    this.state = {
      imei: '',
      validationErrorMessage: '',
      inputErrorStatus: false,
      buttonErrorStatus: true,
      loading: false
    };
    this.searchImei = this.searchImei.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.handleEnterKey = this.handleEnterKey.bind(this);
  }

  searchImei() {
    if (!this.state.buttonErrorStatus) {
      this.setState({loading: true});
      this.props.actions.searchImei(this.state.imei);
    }
  }

  onChangeInput(event) {
    const value = event.target.value;
    const imeiLength = value.length;
    if (value === "") {
      this.setState({
        validationErrorMessage: errorMessages.INPUT_EMPTY,
        inputErrorStatus: true,
        buttonErrorStatus: true
      });
    } else if (!(value.match(/^[0-9]+$/))) {
      this.setState({
        validationErrorMessage: errorMessages.NOT_HALF_WIDTH_NUMBERS,
        inputErrorStatus: true,
        buttonErrorStatus: true
      });
    } else if (imeiLength !== 15 && imeiLength !== 16) {
      this.setState({
        validationErrorMessage: errorMessages.INVALID_DIGITS,
        inputErrorStatus: true,
        buttonErrorStatus: true
      });
    } else {
      this.setState({
        validationErrorMessage: '',
        inputErrorStatus: false,
        buttonErrorStatus: false
      });
    }
    this.setState({ imei: value });
  }

  handleEnterKey(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.searchImei();
    }
  }

  render() {

    return (
      <Fragment>
        { !this.props.imeiSearch.displayResult && <p className="adj-mt-16">お持ちの携帯電話機がネットワーク利用制限の対象となっているかどうかの確認方法をご案内します。</p>}
        <main id={"content"} className={"main"}>
          { !this.props.imeiSearch.displayResult &&
          <div className="inner2">
            <div className="adj-mt-60">
              <h2 className="">ネットワーク利用制限とは</h2>
              <p
                className="adj-mt-16">不正契約・不正取得した携帯電話やデータ通信端末の通話（着信含む）・通信の利用を制限することです。</p>
              <div className="adj-mt-32 adj-center">
                <img src={require("../img/img01.png")} alt="" width="343"/>
              </div>
              <p
                className="adj-mt-32">不正に入手された携帯電話機が「振り込め詐欺」などの犯罪に利用されることを防止するために、一定の条件に該当する携帯電話機に対して楽天回線のネットワーク利用制限を実施させていただく場合があります。
                <br></br>
                正規取扱店以外で購入した携帯電話機が不正に契約・取得されたものである場合、利用制限の対象となる可能性があります。オークションや中古市場でご購入いただく場合はご注意ください。
              </p>
              <p className="adj-mt-16 txt-note">※
                一度ネットワーク利用制限を実施した携帯電話機の利用制限解除はいたしませんのでご注意ください。</p>
            </div>

            <div className="adj-mt-40">
              <h2 className="">ネットワーク利用制限携帯電話機照会</h2>

              <dl className="input-wrap">
                <dt className="adj-mb-16">IMEI（半角数字15桁）を入力してください。</dt>
                <dd>
                  <input
                    id="imei"
                    maxLength="16"
                    name="imei"
                    size="16"
                    type="tel"
                    placeholder="IMEI"
                    onChange={this.onChangeInput}
                    onKeyPress={this.handleEnterKey}
                    className={`${this.state.inputErrorStatus && "is-error"}`} />
                  <p className="validation-error adj-mt-8">{this.state.validationErrorMessage}</p>
                </dd>
              </dl>

              <div className="area-info adj-mt-40">
                <p>IMEIとは携帯電話機の製造番号です。携帯電話機を操作してIMEIを確認してください。</p>
                <p className="adj-right adj-mt-16"><a href="https://network.mobile.rakuten.co.jp/support/restriction/">IMEIの確認方法 &gt;</a></p>
              </div>

              <div className="adj-mt-40 btn-submit">
                <span id="search" className={`btn-next ${(this.state.loading || this.state.buttonErrorStatus) && "is-disabled"}`} onClick={this.searchImei} onKeyPress={this.handleEnterKey}>
                  <span><span>確認する</span></span>
                </span>
              </div>
            </div>

            <div className="adj-mt-32">
              <h2 className="">ネットワーク利用制限がかかる原因</h2>
              <p className="adj-mt-16">以下の項目に該当する携帯電話機を用いた楽天モバイルのサービスについては、利用を制限する場合があります。また、ネットワーク利用制限携帯電話機の表示結果が「△」や「✕」になっている場合は、以下の項目に該当している可能性があります。</p>
              <ol className="adj-mt-16 list-ordered">
                <li>窃盗（盗難）や詐欺等の犯罪行為、その他法令に違反する行為（携帯電話不正利用防止法違反、文書偽造等）により不正に取得された場合</li>
                <li>申し込みの記入内容（氏名・住居・生年月日等）に虚偽の事項が含まれている場合</li>
                <li>申し込み内容に記入された連絡先に対し当社からの請求書等の郵便物が届かない場合</li>
                <li>
                  <p>代金債務（立て替え払いによる分割支払金債務を含む）の履行がなされていない、またその恐れが高い場合</p>
                  <ul className="list-text-disc ">
                    <li>分割支払金のお支払い中は利用いただけますが、表示結果は「△」となります。分割支払金のお支払い完了が楽天モバイルにて反映後、問題がなければ順次表示結果が「〇」となります。</li>
                  </ul>
                </li>
              </ol>
            </div>
          </div>
          }

          { this.props.imeiSearch.displayResult && this.props.imeiSearch.result!=="Error"
          && <ImeiSearchResult result={this.props.imeiSearch.result} imei={this.props.imeiSearch.imei} date={new Date()}/> }

          { this.props.imeiSearch.result ==="Error" && <ErrorWrongApproach/>}
        </main>
      </Fragment>
    );

  }

}

ImeiSearchPage.propTypes = {
  actions: PropTypes.object.isRequired,
  imeiSearch: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    imeiSearch: state.imeiSearch
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImeiSearchPage);
